import React, { memo } from 'react'
import { RadioGroup } from 'transfix-ui/components/RadioGroup'
import { yesOrNo } from 'utils/formatText'

interface IRadioProps {
  id: string
  label: string
  /**
   * @note null will leave all options blank/unchecked
   */
  value?: boolean | null
  onChange: (...args: any[]) => any
  options: {
    id: string
    label: string
    value: string
  }[]
}
const Radio: React.FunctionComponent<IRadioProps> = memo(
  ({ id, label, onChange, options, value }) => (
    <div className='col-xs-7'>
      <RadioGroup
        label={label}
        required={false}
        name={id}
        onOptionChange={onChange}
        checked={yesOrNo(value)}
        options={options}
      />
    </div>
  )
)

export default Radio
